import { appendResponseHeader, removeResponseHeader } from 'h3';

export default defineNuxtRouteMiddleware(async (to) => {
  const rc = useRuntimeConfig();
  const localePath = useLocalePath();
  const article = useState<ArticleDetails | null>('currentArticle', () => null);

  const articleId = to.params.id ? Number(to.params.id) : 0;
  const articleSlug = to.params.slug as string;
  const isPreview = to.name?.toString().includes('preview') ?? false;

  let redirectUrl: string | null = null;
  let errorStatus: number = 500;

  const { data, error } = await useFetch<{ data: ArticleDetails }>(`/v2/magazine/${articleId}/${articleSlug}`, {
    baseURL: rc.public.wadApiBaseUrl,
    params: { preview: isPreview ? 1 : 0 },
    ...(import.meta.server ? { redirect: 'manual' } : {}),
    onResponse({ response }) {
      if(response.status === 301 && response._data) {
        redirectUrl = localePath({
          name: 'magazine-id-slug',
          params: {
            id: response._data.article_id ?? 0,
            slug: response._data.article_slug ?? null,
          },
        });
      }
    },
    onResponseError({ response }) {
      errorStatus = response.status as number;
    },
  });

  if(error.value) {
    throw showError({ statusCode: errorStatus, fatal: true });
  }

  if(redirectUrl) {
    return navigateTo(redirectUrl, { redirectCode: 301 });
  }

  article.value = data.value ?? null;

  // Apply Cloudflare cache headers (server-side only, non-preview, non-authenticated)
  const { isAuthenticated } = useAuthUser();
  if(import.meta.server && !isPreview && !isAuthenticated.value) {
    const event = useRequestEvent();
    if(event) {
      const hours = 720;
      const seconds = hours * 60 * 60;
      const browserSeconds = Math.min(seconds, 3600);

      removeResponseHeader(event, 'Set-Cookie');
      appendResponseHeader(event, 'Cloudflare-CDN-Cache-Control', `public, max-age=${seconds}, immutable`);
      appendResponseHeader(event, 'Cache-Control', `public, max-age=${browserSeconds}, immutable`);
      appendResponseHeader(event, 'Cache-Tag', `magazine-articles,magazine-articles-${articleId}`);
    }
  }
})
